import axios from "axios";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: `${apiBaseUrl}api`,
});

const getAccessToken = () => {
  return localStorage.getItem("AlEzziAdminToken");
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    handleTokenErrors(error);
    return Promise.reject(error);
  },
);

export const handleTokenErrors = (error) => {
  if (error?.response?.data?.error === "jwt expired") {
    localStorage.removeItem("AlEzziAdminToken");
    window.location.href = "/";
  }
};

export default axiosInstance;
